<template>
  <v-container grid-list-lg>
    <v-form v-model="valid" ref="form" lazy-validation>
      <!-- <div class="height-auto" v-resize="onResize" :style="setAutoHeight"> -->
      <div class="height-auto">
        <v-layout class="layout-block" row wrap>
          <edit-actions
            v-if="actionsEdit"
            @change="changeDisplay"
            @save="save"
            :valid="valid"
            class="mb-0"
            :displayMode="isDisplayMode">
          </edit-actions>
          <!-- <v-flex xs12 sm12 class="full-flex pb-0" v-if="hasInvestigator">
            <v-switch
              label="Ativar dados inteligentes?"
              v-model="isActiveSmartData"
              class="simple-switch"
              @click="setSmartData"
            ></v-switch>
          </v-flex> -->
          <!-- <v-flex xs12 sm6 class="full-flex">
            <display-field
              v-if="isDisplayMode"
              :value="items.document"
              label="CPF">
            </display-field>
            <div v-else>
              <v-text-field
                v-if="actionsEdit"
                label="CPF"
                v-model="dataItems.document"
                disabled
              ></v-text-field>
              <v-text-field
                v-else
                label="CPF"
                v-model="dataItems.document"
                :loading="loading"
                :rules="validate.cpfRules"
                :mask="mask.cpf"
                data-cy="userCpf"
                required
                ref="document"
                @blur="blurField"
              ></v-text-field>
            </div>

          </v-flex> -->

          <!-- <v-flex xs12 sm6 class="full-flex">
            <display-field
              v-if="isDisplayMode"
              :value="items.dateBirth"
              label="Data de nascimento">
            </display-field>
            <v-text-field
              v-else
              label="Data de nascimento"
              v-model="dataItems.dateBirth"
              :rules="validate.requiredRules"
              @blur="blurField"
              :mask="mask.date"
              :return-masked-value="true"
              required
              data-cy="userBirthDate"
              :disabled="isDisabled"
            ></v-text-field>
          </v-flex> -->
        <!-- </v-layout>
        <v-layout class="layout-block"> -->
          <v-flex xs12 sm6 class="full-flex">
            <display-field
              v-if="isDisplayMode"
              :value="items.name"
              label="Nome completo">
            </display-field>
            <v-text-field
              v-else
              label="Nome completo"
              v-model="dataItems.name"
              :rules="validate.requiredRules"
              required
              @blur="blurField"
              data-cy="userName"
              :disabled="isDisabled"
              >
            </v-text-field>
          </v-flex>

          <v-flex xs12 sm6 class="full-flex">
            <display-field
              v-if="isDisplayMode"
              :value="items.email"
              label="E-mail"
              >
            </display-field>
            <div v-else>
              <v-text-field
                v-if="actionsEdit"
                label="Email"
                v-model="items.email"
                disabled
              ></v-text-field>
              <v-text-field
                v-else
                type= "email"
                label="Email"
                v-model="dataItems.email"
                disabled
                readonly
                @blur="blurField"
                data-cy="userEmail"
                >
              </v-text-field>
            </div>
          </v-flex>
        </v-layout>

        <v-btn
          flat
          class="ml-0"
          v-if="phoneActions && showButtonPhone && !isDisplayMode"
          small
          color="accent"
          data-cy="userAddPhone"
          @click="addPhone">Adicionar telefone
        </v-btn>

        <!-- <div v-if="phoneActions || showAddPhones"> -->
        <div v-if="phoneActions || showAddPhones">
          <v-flex xs12 sm6 v-if="isDisplayMode">
            <display-field
              v-if="hasPhones"
              :value="items.phones"
              label="Telefones">
            </display-field>
          </v-flex>
          <v-layout v-else class="layout-block" row wrap v-for="(phone, index) in newPhones" :key="`phone-${index}`">
            <v-flex xs12 sm6>
              <!-- <field-phone @change="changeNewPhone" :index="index" :options="phones" dataCy="userPhone" label="Número" /> -->
            </v-flex>
            <v-flex xs12 sm6>
              <v-tooltip top v-if="showRemoveAction(index)">
                <v-btn fab small slot="activator" class="elevation-0" @click="removePhone(index)">
                  <v-icon small dark color="error">{{$root.icons.action.remove}}</v-icon>
                </v-btn>
                <span>Remover telefone</span>
              </v-tooltip>
              <v-tooltip top v-if="showAddAction(index)">
                <v-btn fab small slot="activator" class="elevation-0" @click="addPhone">
                  <v-icon small dark color="success">{{$root.icons.action.add}}</v-icon>
                </v-btn>
                <span>Adicionar telefone</span>
              </v-tooltip>
            </v-flex>
          </v-layout>
        </div>
      </div>

      <div class="pb-2 actions-step-fixed" v-if="!actionsEdit && !displayMode" :class="`text-xs-${btnPosition}`">
        <v-btn
          v-if="btnCancelShow"
          title="Voltar ao passo anterior"
          depressed
          flat
          class="textColor--text"
          @click.native="cancel"
        >
          {{btnCancelLabel}}
        </v-btn>
        <v-btn
          v-if="!hideSubmit"
          @click="submit"
          :disabled="!valid"
          color="accent"
          :loading="isLoading"
          data-cy="userSubmit"
          title="Ir para o próximo passo"
        >
          {{submitLabel}}
        </v-btn>
      </div>
    </v-form>
    <!-- <modal
      :show="modalSmartData"
      @close="closeModalSmart"
      @submit="saveModalSmart"
      btnPrimaryLabel="Quero pagar por isso"
      >
      <span slot="title">Ativar dados inteligentes?</span>
      <div slot="content">
        <p>A consulta por CPF retornará dados inteligentes facilitando o prenchimento dos campos (email, telefone e endereço)</p>
        <p>Esse benefício terá um custo de R$ XX,00 para a consulta de somente um CPF e será descontado do seu ....</p>
      </div>
    </modal> -->
  </v-container>
</template>

<script>
import { states } from '@/utils'
import mixin from './mixin'
// import DatePicker from '@/components/ui/DatePicker'
// import FieldPhone from '@/components/ui/FieldPhone'
// import Modal from '@/components/ui/Modal'

export default {
  mixins: [ mixin ],
  // components: { DatePicker, SelectEmails, FieldPhone, Modal },
  props: {
    phoneActions: {
      type: Boolean,
      default: false
    },
    emailActions: {
      type: Boolean,
      default: false
    },
    hasInvestigator: {
      type: Boolean,
      default: false
    },
    requiredPhone: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    modalSmartData: false,
    acceptSmartData: false,
    showAddPhones: false,
    isActiveSmartData: false,
    changePhone: false,
    states: states,
    emails: [],
    phones: [],
    newPhones: [],
    loading: false,
    isEmptyData: null
  }),
  methods: {
    removePhone (index) {
      this.newPhones.splice(index, 1)
      this.dataItems.phones.splice(index, 1)
    },
    addPhone () {
      let phone = {
        areaCode: '',
        countryCode: '',
        number: '',
        type: ''
      }
      this.newPhones.push(phone)
    },
    showAddAction (index) {
      return this.newPhones.length === parseInt(index) + 1
    },
    showRemoveAction (index) {
      if (this.requiredPhone && this.newPhones.length === 1) {
        return false
      } else {
        return this.newPhones.length === index + 1
      }
    },
    saveDate (date) {
      var setDate = {dateBirth: date}
      this.dataItems = Object.assign(this.dataItems, setDate)
    },
    blurField () {
      this.$emit('blur', this.dataItems)
      this.isDisplayMode = false
      // this.newPhones = Object.assign([], this.items.phones)
    },
    // setDisabledFields () {
    //   if (this.$route.name === 'CompanyNew' || this.$route.name === 'UserNew' || this.$route.name === 'CaseNew') {
    //     this.isDisabled = true
    //   }
    // },
    changeEmail (email) {
      this.dataItems.email = email.join()
    },
    changeNewPhone (selectedPhone, index) {
      let objectPhone = selectedPhone[0] // only phone
      this.changePhone = true
      this.dataItems.phones.splice(index, 1, objectPhone)
      // console.log('phones selecionados', this.dataItems.phones)
      this.$emit('blur', this.dataItems)
    },
    clearFields () {
      this.acceptSmartData = false
      this.dataItems.name = ''
      this.dataItems.dateBirth = ''
      this.dataItems.email = ''
      this.emails = []
      // this.newPhones = []
      this.isEmptyData = true
    },
    setNotData () {
      this.isEmptyData = false
    },
    setSmartData () {
      this.$nextTick(() => { this.modalSmartData = true })
    },
    closeModalSmart () {
      this.modalSmartData = false
      this.isActiveSmartData = this.acceptSmartData
    },
    saveModalSmart () {
      this.acceptSmartData = true
      this.closeModalSmart()
      this.$nextTick(() => { this._focusDocumentField() })
    },
    _focusDocumentField () {
      if (this.dataItems.document === '') {
        this.$refs.document.focus()
      }
    },
    getInvestigator (cpf) {
      this.$apollo.mutate({
        mutation: gql.SEARCH_PERSON,
        variables: { cpf }
      }).then(({data: {searchPersonByCpf: {investigator}}}) => {
        // if (!errors) {
        //   this.errorDocument.push('Erro, digite o cpf novamente')
        //   return false
        // }
        this.loading = false
        this.isDisabled = false

        if (investigator !== null) {
          this.dataItems.name = investigator.name
          this.dataItems.dateBirth = investigator.dateBirth
          this.emails = investigator.emails
          let phones = investigator.phones.map((phone) => {
            let {
              isActive,
              isMain,
              isRecent,
              priority,
              __typename,
              ...updatedPhones
            } = phone
            return updatedPhones
          })
          this.phones = phones
          this.$emit('investigator', investigator)
        }
        // this.$emit('investigator', investigator)
        // this.$emit('investigator', {})
      })
    },
    _checkRequirePhoneProp () {
      this.requiredPhone && this.addPhone()
    }
  },
  mounted () {
    this.dataItems = Object.assign({}, this.items)
    this._checkRequirePhoneProp()
    this.isDisabled = this.editAction
    this.showAddPhones = this.requiredPhone
  },
  watch: {
    items (val) {
      this.dataItems = val
      this.showAddPhones = this.requiredPhone
      this._checkRequirePhoneProp()
    },
    'dataItems.document' (cpf) {
      // this.hasInvestigator && cpf !== null && cpf.length < 11 ? this.clearFields() : this.setNotData()
      // if (this.cpfRules[1](cpf) === true) {
      //   this.getInvestigator(cpf)
      // }
    },
    isEmptyData (isEmpty) {
      this.$emit('empty', isEmpty)
    },
    requiredPhone (value) {
      this.showAddPhones = this.changePhone = value
      this._checkRequirePhoneProp()
    }
  },
  computed: {
    isLoading () {
      return this.$store.state.isLoading
    },
    hasPhones () {
      return this.items.phones !== undefined
    },
    showButtonPhone () {
      return this.newPhones.length === 0
    }
  }
}
</script>
